import React from 'react';
import { cn } from '@/lib/utils';
import { AlertTriangle } from 'lucide-react';
import { Button } from './button';

export interface ErrorStateProps extends React.HTMLAttributes<HTMLDivElement> {
  title?: string;
  description?: string;
  onRetry?: () => void;
  fullScreen?: boolean;
}

export const ErrorState = React.forwardRef<HTMLDivElement, ErrorStateProps>(
  ({ className, title = 'Something went wrong', description = 'An unexpected error occurred while loading this content.', onRetry, fullScreen, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          'flex flex-col items-center justify-center p-8 text-center bg-destructive/10 rounded-lg',
          fullScreen ? 'min-h-[60vh] bg-background' : 'min-h-[250px]',
          className
        )}
        {...props}
      >
        <div className="mb-4 text-destructive p-4 bg-destructive/20 rounded-full">
          <AlertTriangle className="h-10 w-10" />
        </div>
        <h3 className="text-xl font-bold text-foreground mb-2">{title}</h3>
        <p className="text-sm text-muted-foreground max-w-md mb-6">{description}</p>
        
        {onRetry && (
          <Button onClick={onRetry} variant="default">
            Try Again
          </Button>
        )}
      </div>
    );
  }
);

ErrorState.displayName = 'ErrorState';
